import { render, staticRenderFns } from "./user-recommendations-mobile.vue?vue&type=template&id=5428b7f8&scoped=true&lang=pug&"
import script from "./user-recommendations-mobile.vue?vue&type=script&lang=js&"
export * from "./user-recommendations-mobile.vue?vue&type=script&lang=js&"
import style0 from "./user-recommendations-mobile.scss?vue&type=style&index=0&id=5428b7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428b7f8",
  null
  
)

export default component.exports